import React from 'react'
import { useTranslation } from 'react-i18next'
import KibDivider from '@chewy/kib-divider-react'
import { KibContainer } from '@chewy/kib-layout-react'
import { NumberUtils } from '@pbt/pbt-ui-components'

import { useRefundDialog } from '../context/RefundDialogProvider'

import '@chewy/kib-layout-styles/dist/styles/kib-container.css'
import styles from './RefundSuccessScreen.module.scss'

export const RefundSuccessScreen = () => {
  const { t } = useTranslation(['Dialogs', 'Common'])
  const { dialogState } = useRefundDialog()
  const { refundAmount, selectedPayment } = dialogState

  const getRefundMethodDisplay = (): string => {
    if (!selectedPayment) {
      return ''
    }

    const paymentMethod = selectedPayment.method?.name || ''
    const isCreditCard = selectedPayment.cardType && selectedPayment.lastFour

    if (isCreditCard) {
      return t('Dialogs:ADD_PAYMENT_DIALOG_V2.CREDIT_DEBIT_SUCCESS', {
        method: paymentMethod,
        creditCardType: selectedPayment.cardType?.name,
        creditLastFour: selectedPayment.lastFour,
      })
    }

    return paymentMethod
  }

  return (
    <KibContainer className={styles.refundSuccessContainer}>
      <div className={styles.refundSuccessTitle}>
        {t('Common:PAYMENTS.REFUND_DETAILS')}
      </div>
      <div className={styles.refundSuccessInfoRow}>
        <div className={styles.refundSuccessInfoRowLabel}>
          {t('Common:PAYMENTS.AMOUNT_REFUNDED')}
        </div>
        <div className={styles.refundSuccessInfoRowValue}>
          {NumberUtils.formatMoney(refundAmount)}
        </div>
      </div>
      <KibDivider className={styles.refundSuccessDivider} color="alternate" />
      <div className={styles.refundSuccessInfoRow}>
        <div className={styles.refundSuccessInfoRowLabel}>
          {t('Common:PAYMENTS.PAYMENT_METHOD')}
        </div>
        <div className={styles.refundSuccessInfoRowValue}>
          {getRefundMethodDisplay()}
        </div>
      </div>
      <KibDivider className={styles.refundSuccessDivider} color="alternate" />
    </KibContainer>
  )
}
